import { withNamespaces } from "react-i18next";
import { Badge, Card, CardBody, CardHeader, Col, Row } from "reactstrap";

const ComplianceRecommendations = ({ complianceQuery, t }) => {
    if (complianceQuery.isFetching) return null;

    const {
        orchestration
    } = complianceQuery.data?.data || {};

    const recommendations = orchestration?.decisionSupport?.monitoringRecommendations || [];

    if (!recommendations.length) return null;

    return (
        <Card className="mb-4">
            <CardHeader>
                <h5 className="mb-0">
                    {t(orchestration.decision === "no_go"
                        ? "Recommended Actions Before Reassessment"
                        : "Monitoring Recommendations")}
                </h5>
            </CardHeader>

            <CardBody>
                <Row>
                    {recommendations.map(item => (
                        <Col
                            lg={6}
                            key={item.id}
                        >
                            <Card className="border mb-3">
                                <CardBody>
                                    <Badge
                                        color="info"
                                        className="bg-info mb-2"
                                    >
                                        {t(item.cadence)}
                                    </Badge>

                                    <div>
                                        {t(item.recommendation)}
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </CardBody>
        </Card>
    )
}

export default withNamespaces()(
    ComplianceRecommendations
);